import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyle = makeStyles({
    loading: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        margin: '-20px',
    },
    textLoading: {
        position: 'absolute',
        top: '60%',
        left: '45%',
        margin: '-20px',
    }

});

const Loading = () => {
    const classes = useStyle();
    return (
        <div>
            <CircularProgress disableShrink className={classes.loading}/>
            <h6 className={classes.textLoading}><strong>Loading...</strong></h6>
        </div>
    );
};

export default Loading;